import * as actionTypes from "./actionTypes";
import * as types from "./types";

// GET Overrides

const initOverridesListState: types.OverrideListState = {
  pending: false,
  overrides: {} as types.IOverrideList,
  error: null,
};

export const OverridesListReducer = (state = initOverridesListState, action: types.OverridesActions) => {
  switch (action.type) {
      case actionTypes.FETCH_OVERRIDES_LIST_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.FETCH_OVERRIDES_LIST_SUCCESS:
          return {
              ...state,
              pending: false,
              overrides: action.payload.overrides,
              error: null,
          };
      case actionTypes.FETCH_OVERRIDES_LIST_FAILURE:
          return {
              ...state,
              pending: false,
              overrides: {} as types.IOverrideList,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};

// GET Override Details

const initOverrideState: types.OverrideState = {
  pending: false,
  override: null,
  error: null,
};

export const OverrideDetailsReducer = (state = initOverrideState, action: types.OverrideActions) => {
  switch (action.type) {
      case actionTypes.FETCH_OVERRIDE_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.FETCH_OVERRIDE_SUCCESS:
          return {
              ...state,
              pending: false,
              override: action.payload.override,
              error: null,
          };
      case actionTypes.FETCH_OVERRIDE_FAILURE:
          return {
              ...state,
              pending: false,
              override: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};


// DELETE Override Details

const initDeleteOverrideState: types.IDeleteOverrideState = {
  pending: false,
  success: null,
  error: null,
};

export const DeleteOverrideReducer = (state = initDeleteOverrideState, action: types.DeleteOverrideActions) => {
  switch (action.type) {
      case actionTypes.DELETE_OVERRIDE_REQUEST:
          return {
              ...state,
              success: null,
              pending: true,
          };
      case actionTypes.DELETE_OVERRIDE_SUCCESS:
          return {
              ...state,
              pending: false,
              success: action.success,
              error: null,
          };
      case actionTypes.DELETE_OVERRIDE_FAILURE:
          return {
              ...state,
              pending: false,
              success: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }
};


// POST Override

const initialStateOverride: types.IPostOverrideState = {
  pending: false,
  override: null,
  error: null,
};

export const PostOverrideReducer = (state = initialStateOverride, action: types.PostOverrideActions) => {

  switch (action.type) {
      case actionTypes.POST_OVERRIDE_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.POST_OVERRIDE_SUCCESS:
          return {
              ...state,
              pending: false,
              override: action.payload.override,
              error: null,
          };
      case actionTypes.POST_OVERRIDE_FAILURE:
          return {
              ...state,
              pending: false,
              override: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }

};


// PUT Override

const initialStatePutOverride: types.IPutOverrideState = {
  pending: false,
  override: null,
  error: null,
};

export const PutOverrideReducer = (state = initialStatePutOverride, action: types.PutOverrideActions) => {
      switch (action.type) {

      case actionTypes.PUT_OVERRIDE_REQUEST:
          return {
              ...state,
              pending: true,
          };
      case actionTypes.PUT_OVERRIDE_SUCCESS:
          return {
              ...state,
              pending: false,
              override: action.payload.override,
              error: null,
          };
      case actionTypes.PUT_OVERRIDE_FAILURE:
          return {
              ...state,
              pending: false,
              override: null,
              error: action.payload.error,
          };
      default:
          return {
              ...state,
          };
  }

};

